import { motion } from "framer-motion";

export default function ServiceCard({ title, description, icon: Icon }) {
  return (
    <motion.div
      whileHover={{ y: -10 }}
      transition={{ type: "spring", stiffness: 180 }}
      className="group p-8 rounded-2xl bg-white dark:bg-[#0B1022]
      border border-black/5 dark:border-white/10
      shadow-md hover:shadow-xl transition"
    >
      {/* Icon */}
      <div
        className="w-12 h-12 flex items-center justify-center rounded-xl
        bg-blue-600/10 text-blue-600 mb-6
        group-hover:bg-blue-600 group-hover:text-white transition"
      >
        <Icon size={22} />
      </div>

      {/* Content */}
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
        {description}
      </p>
    </motion.div>
  );
}
